const notesWithoutFlats = {
  trumpet: [
    'F#3',
    'G3',
    'G#3',
    'A3',
    'A#3',
    'B3',
    'B#3',
    'C4',
    'C#4',
    'D4',
    'D#4',
    'E4',
    'E#4',
    'F4',
    'F#4',
    'G4',
    'G#4',
    'A4',
    'A#4',
    'B4',
    'B#4',
    'C5',
    'C#5',
    'D5',
    'D#5',
    'E5',
    'E#5',
    'F5',
    'F#5',
    'G5',
    'G#5',
    'A5',
    'A#5',
    'B5',
    'B#5',
    'C6',
  ],
  frenchHorn: [
    'F3',
    'F#3',
    'G3',
    'G#3',
    'A3',
    'A#3',
    'B3',
    'B#3',
    'C4',
    'C#4',
    'D4',
    'D#4',
    'E4',
    'E#4',
    'F4',
    'F#4',
    'G4',
    'G#4',
    'A4',
    'A#4',
    'B4',
    'B#4',
    'C5',
    'C#5',
    'D5',
    'D#5',
    'E5',
    'E#5',
    'F5',
    'F#5',
    'G5',
    'G#5',
    'A5',
    'A#5',
    'B5',
    'B#5',
    'C6',
  ],
  trombone: [
    'E2',
    'E#2',
    'F2',
    'F#2',
    'G2',
    'G#2',
    'A2',
    'A#2',
    'B2',
    'B#2',
    'C3',
    'C#3',
    'D3',
    'D#3',
    'E3',
    'E#3',
    'F3',
    'F#3',
    'G3',
    'G#3',
    'A3',
    'A#3',
    'B3',
    'B#3',
    'C4',
    'C#4',
    'D4',
    'D#4',
    'E4',
    'E#4',
    'F4',
    'F#4',
    'G4',
    'G#4',
    'A4',
    'A#4',
  ],
  euphonium: [
    'E2',
    'E#2',
    'F2',
    'F#2',
    'G2',
    'G#2',
    'A2',
    'A#2',
    'B2',
    'B#2',
    'C3',
    'C#3',
    'D3',
    'D#3',
    'E3',
    'E#3',
    'F3',
    'F#3',
    'G3',
    'G#3',
    'A3',
    'A#3',
    'B3',
    'B#3',
    'C4',
    'C#4',
    'D4',
    'D#4',
    'E4',
    'E#4',
    'F4',
    'F#4',
    'G4',
    'G#4',
    'A4',
    'A#4',
  ],
  tuba: [
    'E1',
    'E#1',
    'F1',
    'F#1',
    'G1',
    'G#1',
    'A1',
    'A#1',
    'B1',
    'B#1',
    'C2',
    'C#2',
    'D2',
    'D#2',
    'E2',
    'E#2',
    'F2',
    'F#2',
    'G2',
    'G#2',
    'A2',
    'A#2',
    'B2',
    'B#2',
    'C3',
    'C#3',
    'D3',
    'D#3',
    'E3',
    'E#3',
    'F3',
    'F#3',
    'G3',
    'G#3',
    'A3',
    'A#3',
  ],
};

export { notesWithoutFlats };
